"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_2fxghynmpi() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Edit.tsx";
  var hash = "a3504ea37bcf336109c62ee8f50398ca8b3b238b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Edit.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a3504ea37bcf336109c62ee8f50398ca8b3b238b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2fxghynmpi = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2fxghynmpi();
var Icon = (cov_2fxghynmpi().s[0]++, {
  name: 'edit',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.2982 2.53033C19.029 1.26113 16.9712 1.26113 15.702 2.53033L3.946 14.2863L1.83597 19.2097C1.03588 21.0766 2.92349 22.9642 4.79036 22.1641L9.71376 20.0541L21.4698 8.2981C22.739 7.0289 22.739 4.97111 21.4698 3.70191L20.2982 2.53033ZM17.4698 4.2981C17.7627 4.00521 18.2375 4.00521 18.5304 4.2981L19.702 5.46967C19.9949 5.76257 19.9949 6.23744 19.702 6.53033L18.2501 7.98224L16.0179 5.75001L17.4698 4.2981ZM14.2501 7.51777L7.51786 14.25L9.7501 16.4822L16.4823 9.75001L14.2501 7.51777ZM7.86069 18.1284L5.87174 16.1394L4.38003 19.6201L7.86069 18.1284Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;